import { version } from '../../package.json';

export type RequestParams = {
	url: string;
	baseUrl?: string,
	method?: string;
	body?: string | FormData | object;
	headers?: { [key: string]: string }
}
export type ApiFailResponse = {
	error: true;
	error_code: string | string[];
	error_message: string
}

export class RequestException<ErrorResponse = ApiFailResponse> extends Error {
	response?: ErrorResponse;
	status: number;
}

export async function request<E = {}>(params: RequestParams) {
	const { url, method = 'get', baseUrl = '', body, headers = {} } = params || {};
	let data;

	if (method.toLowerCase() !== 'get') {
		switch (true) {
			case typeof body === 'string':
				data = body;
				break;
			case body instanceof FormData:
				data = body;
				break;
			case body !== null && body !== undefined:
				data = JSON.stringify(body);
				headers['content-type'] = 'application/json';
				break;
		}
	}
	const response = await fetch(baseUrl + url, {
		method,
		body: data,
		headers: {
			...headers,
			'x-sdk-version': version,
			mode: 'no-cors',
		},
	});
	if (response.ok) {
		return response.json();
	}
	const error = new RequestException<E>(response.statusText);
	if (response.status < 400 || response.status >= 500) {
		error.status = response.status;
		throw error;
	}
	error.response = await response.json();
	error.status = response.status;
	throw error;
}
